import { QueryClient } from "@tanstack/react-query";
import SnackbarUtils from "../components/Snackbar/utils";

/**
 * Global error handler for React Query.
 * Shows a snackbar for failed queries unless the error is explicitly silenced.
 */
function onQueryError(error) {
  const message = error?.response?.data?.message || error?.message || "An unexpected error occurred";
  const status = error?.response?.status;

  // Don't show toast for cancelled requests or 401 (handled by interceptor)
  if (error?.code === "ERR_CANCELED" || status === 401) return;

  SnackbarUtils.error(message);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes — data considered fresh
      cacheTime: 10 * 60 * 1000, // 10 minutes — cache kept in memory
      refetchOnWindowFocus: false, // Don't refetch when tab regains focus
      refetchOnReconnect: true, // Refetch when network reconnects
      retry: 1, // Retry failed requests once (Api.js already has retry-on-504)
      onError: onQueryError,
    },
    mutations: {
      onError: onQueryError,
    },
  },
});

export default queryClient;
